import { apiFetcher } from '@gjensidige/service-async';
import { AutocompleteAddressOption } from '@gjensidige/se-common-calculation';

import { selectEnvironment } from './constant';

interface ResponseType {
  calculationStatus: {
    error: false;
  };
  customerName: '';
  adress: '';
  zipCode: '';
  cpr: '';
}

interface AutocompleteResponse {
  items: AutocompleteAddressOption[];
}
const environment_urls = selectEnvironment();
const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const getAddressDetails = async (validSSN: number) => {
  if (process.env.NODE_ENV !== 'production') {
    await delay(5000);
    if (validSSN == 197110021834)
      return {
        calculationStatus: {
          error: false
        },
        customerName: 'Bengt',
        adress: 'Daliavägen 5',
        zipCode: '73723',
        cpr: '197110021834'
      };
  }
  const url = environment_urls.getAddressURL + '/' + validSSN;
  const response = await apiFetcher.getJson<ResponseType>(url, {
    cache: 'no-cache',
    headers: {
      Applikasjon: 'GFSEWEBSHOP'
    }
  });
  if (response.isOk()) {
    return response.value;
  }
  return {
    calculationStatus: {
      error: true
    },
    customerName: '',
    adress: '',
    zipCode: '',
    cpr: ''
  };
};

export const getAutocompleteAddressOptions = async (
  address: string,
  signal?: AbortSignal
): Promise<AutocompleteAddressOption[]> => {
  if (process.env.NODE_ENV !== 'production') {
    await delay(2000);
    // Mock data for development
    return [
      {
        "adress": "Katrineholm Floda Västra Granhed Stalltorp 64197 Katrineholm",
        "adressComponents": {
          "adressomrade": "Västra Granhed",
          "adressplatsnummer": null,
          "bokstavstillagg": null,
          "kommun": "Katrineholm",
          "kommundel": "Floda",
          "postnummer": 64197,
          "postort": "Katrineholm"
        },
        "objektidentitet": "95a2e08f-245a-4c02-a419-1802204be292"
      },
      {
        "adress": "Katrineholm Floda Västra Granhed Stalltorp 2 64197 Katrineholm",
        "adressComponents": {
          "adressomrade": "Västra Granhed",
          "adressplatsnummer": "2",
          "bokstavstillagg": "B",
          "kommun": "Katrineholm",
          "kommundel": "Floda",
          "postnummer": 64197,
          "postort": "Katrineholm"
        },
        "objektidentitet": "d1994909-bddc-4b26-b23c-d54cb7283fde"
      },
      {
        "adress": "Katrineholm Floda Västra Granhed Stalltorp 3 64197 Katrineholm",
        "adressComponents": {
          "adressomrade": "Västra Granhed",
          "adressplatsnummer": "3",
          "bokstavstillagg": null,
          "kommun": "Katrineholm",
          "kommundel": "Floda",
          "postnummer": 64197,
          "postort": "Katrineholm"
        },
        "objektidentitet": "d290ee44-dfb0-473b-b634-9edf65e4985a"
      },
      {
        "adress": "Katrineholm Floda Västra Granhed Stalltorp 4 64197 Katrineholm",
        "adressComponents": {
          "adressomrade": "Västra Granhed",
          "adressplatsnummer": "4",
          "bokstavstillagg": null,
          "kommun": "Katrineholm",
          "kommundel": "Floda",
          "postnummer": 64197,
          "postort": "Katrineholm"
        },
        "objektidentitet": "49ed4035-a428-48fd-adb0-1a700480c3ea"
      }
    ];
  }

  const uriEncodedAddress = encodeURIComponent(address.replace(/,/g, ''));
  const maxHits = 4;

  const url = `${environment_urls.getAutocompleteURL}/${uriEncodedAddress}?maxHits=${maxHits}`;
  const response = await apiFetcher.getJson<AutocompleteResponse>(url, {
    cache: 'no-cache',
    headers: {
      Applikasjon: 'GFSEEXT'
    }
  });

  if (response.isOk()) {
    return response.value.items || [];
  }

  throw new Error('Failed to fetch address options');
};